{
  " · Tag: {tag}": " · تگ: {tag}",
  "+ Add item": "+ افزودن مورد",
  "+ New list": "+ لیست جدید",
  "+ New project": "+ پروژه جدید",
  "+ New task": "+ تسک جدید",
  "+ tag": "+ تگ",
  "+{n} more, keep typing to narrow": "+{n} مورد دیگر؛ برای محدود کردن نتایج به تایپ ادامه دهید",
  "@{username} is taken": "@{username} قبلاً گرفته شده است",
  "A deleted task": "یک تسک حذف‌شده",
  "A list": "یک لیست",
  "A new version is ready. Your changes are saved on this device.": "نسخهٔ تازه آماده است. تغییرات شما روی این دستگاه ذخیره شده‌اند.",
  "A project": "یک پروژه",
  "A project needs at least one owner": "هر پروژه دست‌کم یک مالک لازم دارد",
  "Accent color": "رنگ تأکیدی",
  "Accept": "پذیرفتن",
  "Accept invitation": "پذیرفتن دعوت",
  "Accepting an invitation needs a connection.": "پذیرفتن دعوت به اتصال اینترنت نیاز دارد.",
  "Account": "حساب کاربری",
  "Across {n} project": "در {n} پروژه",
  "Across {n} projects": "در {n} پروژه",
  "Active in 7 days": "فعال در ۷ روز",
  "Activity": "فعالیت",
  "Add a comment…": "کامنت بنویسید…",
  "Add from Safari": "از سافاری اضافه کنید",
  "Add image to notes": "افزودن تصویر به یادداشت",
  "Add tag": "افزودن تگ",
  "Added": "اضافه‌شده",
  "Added by you": "اضافه‌شده توسط شما",
  "Added by {name}": "اضافه‌شده توسط {name}",
  "Added date unknown": "تاریخ افزودن نامشخص",
  "Added today": "امروز اضافه شد",
  "Added {date} by {name}": "افزوده‌شده در {date} توسط {name}",
  "Added {d}": "اضافه‌شده {d}",
  "Airy": "باز",
  "All": "همه",
  "All Tasks": "همه تسک‌ها",
  "All Tasks & Search": "همه‌ی تسک‌ها و جستجو",
  "Already a member": "از قبل عضو است",
  "Already invited": "از قبل دعوت شده است",
  "Already on this task": "از قبل روی این تسک است",
  "Alternate calendar": "تقویم دوم",
  "An account with this email already exists.": "حسابی با این ایمیل وجود دارد.",
  "Anyone with the link can view, but not edit.": "هر کسی که پیوند را داشته باشد می‌تواند ببیند، اما نمی‌تواند ویرایش کند.",
  "App": "اپلیکیشن",
  "Appearance": "ظاهر",
  "Attach file": "پیوست فایل",
  "Back to column": "بازگشت به ستون",
  "Back to current": "بازگشت به نسخهٔ فعلی",
  "Back to projects": "بازگشت به پروژه‌ها",
  "Back to settings": "بازگشت به تنظیمات",
  "Bold (⌘B)": "پررنگ (⌘B)",
  "Brand & support": "برند و پشتیبانی",
  "Buddhist": "بودایی",
  "Bulleted list": "فهرست نشانه‌دار",
  "By list": "بر اساس لیست",
  "By project": "به تفکیک پروژه",
  "Calendar": "تقویم",
  "Cancel": "انصراف",
  "Cancelled": "لغوشده",
  "Change": "تغییر",
  "Change password": "تغییر رمز عبور",
  "Change photo": "تغییر عکس",
  "Changelog": "تغییرات نسخه‌ها",
  "Changelog language": "زبان چنج‌لاگ",
  "Changelog view": "نمای چنج‌لاگ",
  "Changes saved": "تغییرات ذخیره شد",
  "Changes that need review": "تغییراتی که نیاز به بررسی دارند",
  "Check the email and use a password of at least 8 characters.": "ایمیل را بررسی کنید و رمزی با حداقل ۸ نویسه انتخاب کنید.",
  "Checked": "انجام‌شده",
  "Checklist": "چک‌لیست",
  "Chinese": "چینی",
  "Choose an account to continue.": "برای ادامه یک حساب را انتخاب کنید.",
  "Choose icon": "انتخاب آیکن",
  "Clear": "پاک کردن",
  "Close": "بستن",
  "Close pane": "بستن ستون",
  "Code block": "بلوک کد",
  "Comments & changes": "کامنت‌ها و تغییرات",
  "Compact": "فشرده",
  "Complete": "انجام شد",
  "Completed": "تکمیل‌شده",
  "Completed per week": "تکمیل‌شده در هر هفته",
  "Completion rate": "نسبت تکمیل",
  "Confirm new password": "تکرار رمز عبور جدید",
  "Continue with Google": "ادامه با گوگل",
  "Copy link": "کپی پیوند",
  "Copy my change": "کپی تغییر من",
  "Could not accept the invite": "دعوت پذیرفته نشد",
  "Could not add the image": "افزودن تصویر ممکن نشد",
  "Could not cancel the invite": "دعوت لغو نشد",
  "Could not create the link": "پیوند ساخته نشد",
  "Could not decline the invite": "دعوت رد نشد",
  "Could not delete forever": "حذف همیشگی انجام نشد",
  "Could not load this section. Try again.": "بارگذاری این بخش ممکن نشد. دوباره تلاش کنید.",
  "Could not save your name": "نام شما ذخیره نشد",
  "Could not save your username": "نام کاربری شما ذخیره نشد",
  "Could not send a test notification": "ارسال اعلان آزمایشی ممکن نشد",
  "Could not send invite": "دعوت فرستاده نشد",
  "Could not sync everything. Check your connection, or export your changes.": "همهٔ تغییرات همگام نشد. اتصال را بررسی کنید یا از تغییرات خروجی بگیرید.",
  "Could not turn off notifications": "خاموش کردن اعلان‌ها ممکن نشد",
  "Could not turn off the link": "پیوند خاموش نشد",
  "Could not turn on notifications": "روشن کردن اعلان‌ها ممکن نشد",
  "Could not update sharing": "اشتراک‌گذاری به‌روز نشد",
  "Could not update your photo": "به‌روزرسانی عکس ممکن نشد",
  "Couldn’t save. Changes kept on this device.": "ذخیره نشد. تغییرات روی این دستگاه نگه داشته شد.",
  "Cozy": "معمولی",
  "Create account": "ساخت حساب",
  "Create an account": "ساخت حساب جدید",
  "Create link": "ساخت پیوند",
  "Create your {brand} account": "ساخت حساب {brand}",
  "Current": "فعلی",
  "Current password": "رمز عبور فعلی",
  "Dark": "تیره",
  "Deadline": "مهلت",
  "Deadline reminders": "یادآوری مهلت‌ها",
  "Decline": "رد کردن",
  "Delete comment": "حذف کامنت",
  "Delete empty list": "حذف لیست خالی",
  "Delete forever": "حذف برای همیشه",
  "Delete list": "حذف لیست",
  "Delete project": "حذف پروژه",
  "Delete this project…": "حذف این پروژه…",
  "Delete “{name}” forever?": "«{name}» برای همیشه حذف شود؟",
  "Delete “{name}”?": "«{name}» حذف شود؟",
  "Deleted forever": "برای همیشه حذف شد",
  "Deleted just now": "همین حالا حذف شد",
  "Deleted tasks stay here for 30 days.": "تسک‌های حذف‌شده ۳۰ روز اینجا می‌مانند.",
  "Deleted {r} ago": "{r} پیش حذف شد",
  "Density": "تراکم",
  "Desktop only · after 10 seconds without moving the mouse": "فقط دسکتاپ · پس از ۱۰ ثانیه بدون حرکت موس",
  "Device storage is full. Your change was not saved.": "فضای ذخیره‌سازی دستگاه پر است. تغییر شما ذخیره نشد.",
  "Discard changes and sign out": "دور ریختن تغییرات و خروج",
  "Dismiss": "بستن",
  "Divider": "خط جداکننده",
  "Done": "انجام‌شده",
  "Done · 7 days": "انجام‌شده · ۷ روز",
  "Double-click to open the project": "برای باز کردن پروژه دوبار کلیک کنید",
  "Download": "دانلود",
  "Drag to move column": "برای جابه‌جایی ستون بکشید",
  "Drag to reorder": "برای تغییر ترتیب بکشید",
  "Drag to resize": "برای تغییر اندازه بکشید",
  "Due {date}": "سررسید {date}",
  "Edit": "ویرایش",
  "Editor": "ویرایشگر",
  "Email": "ایمیل",
  "Email or @username, press Enter": "ایمیل یا ‎@نام‌کاربری، سپس Enter",
  "Email or password is incorrect.": "ایمیل یا رمز عبور نادرست است.",
  "Email updates": "به‌روزرسانی‌های ایمیلی",
  "Empty trash": "خالی کردن سطل زباله",
  "Empty trash?": "سطل زباله خالی شود؟",
  "Enter a valid email address": "یک ایمیل معتبر وارد کنید",
  "Enter an email or @username": "یک ایمیل یا ‎@نام‌کاربری وارد کنید",
  "Enter your current password": "رمز عبور فعلی را وارد کنید",
  "Exit full screen": "خروج از تمام صفحه",
  "Export unsynced work": "خروجی کارهای همگام‌نشده",
  "Exports need the “Export data” permission.": "برای خروجی گرفتن به دسترسی «خروجی گرفتن از داده» نیاز است.",
  "File": "فایل",
  "Filter lists and tags": "فیلتر لیست‌ها و تگ‌ها",
  "Forest": "جنگل",
  "Formatting": "قالب‌بندی",
  "Full screen": "تمام صفحه",
  "Google could not be reached. Try again later.": "اتصال به گوگل برقرار نشد. بعداً دوباره تلاش کنید.",
  "Google sign-in failed. Try again.": "ورود با گوگل ناموفق بود. دوباره تلاش کنید.",
  "Google sign-in was cancelled.": "ورود با گوگل لغو شد.",
  "Grace": "مهلت",
  "Grace / past due": "مهلت / سررسید گذشته",
  "Gregorian": "میلادی",
  "Has notes": "یادداشت دارد",
  "Heading 1": "عنوان ۱",
  "Heading 2": "عنوان ۲",
  "Health": "سلامت",
  "Hebrew": "عبری",
  "Help & feedback": "راهنما و بازخورد",
  "Hide done": "پنهان کردن انجام‌شده‌ها",
  "Hide logged items": "پنهان کردن موارد انجام‌شده",
  "Hide logged projects": "پنهان کردن پروژه‌های تمام‌شده",
  "Hide projects": "پنهان کردن پروژه‌ها",
  "High contrast": "کنتراست بالا",
  "Hijri - Civil": "قمری - مدنی",
  "Hijri - Kuwaiti": "قمری - کویتی",
  "Hijri - Saudi": "قمری - سعودی",
  "Home": "خانه",
  "How to install": "روش نصب",
  "I already have an account": "حساب دارم",
  "Icon": "آیکن",
  "Icon categories": "دسته‌های آیکن",
  "Image removed": "تصویر حذف شد",
  "In Safari, tap the Share button, then “Add to Home Screen”.": "در سافاری، دکمه اشتراک‌گذاری را بزنید و سپس «Add to Home Screen».",
  "In a month": "یک ماه بعد",
  "In development": "در حال توسعه",
  "In progress": "در حال انجام",
  "Indian - Saka": "هندی - ساکا",
  "Inline code": "کد درون‌خطی",
  "Install": "نصب",
  "Install Task Panes": "نصب Task Panes",
  "Install TaskCool": "نصب TaskCool",
  "Install {brand}": "نصب {brand}",
  "Installed": "نصب‌شده",
  "Internal plan": "پلن داخلی",
  "Invitation created for {email}": "دعوت‌نامه برای {email} ساخته شد",
  "Invitation not found": "دعوت‌نامه پیدا نشد",
  "Invite by email, press Enter": "دعوت با ایمیل، Enter را بزنید",
  "Invited": "دعوت‌شده",
  "Invites": "دعوت‌ها",
  "It depended on another change that was not applied, so it was not applied either; your text is kept below.": "این تغییر به تغییر دیگری وابسته بود که اعمال نشد، پس این هم اعمال نشد؛ متن شما در زیر حفظ شده است.",
  "It may have been turned off by the project owner.": "ممکن است مالک پروژه آن را خاموش کرده باشد.",
  "It takes a few seconds.": "چند ثانیه بیشتر طول نمی‌کشد.",
  "Italic (⌘I)": "مورب (⌘I)",
  "Its lists, tasks and files are deleted for everyone. This can’t be undone.": "لیست‌ها، تسک‌ها و فایل‌های آن برای همه حذف می‌شوند. این کار برگشت‌پذیر نیست.",
  "Japanese": "ژاپنی",
  "Join {project}": "پیوستن به {project}",
  "Keep mine": "نسخهٔ من بماند",
  "Keep theirs": "نگه داشتن نسخهٔ دیگران",
  "Korean": "کره‌ای",
  "Language": "زبان",
  "Largest projects": "بزرگ‌ترین پروژه‌ها",
  "Last 12 weeks": "۱۲ هفته اخیر",
  "Last 30 days": "۳۰ روز گذشته",
  "Last synced {d}": "آخرین همگام‌سازی {d}",
  "Later": "بعداً",
  "Latest tasks where you were mentioned": "آخرین تسک‌هایی که در آن‌ها منشن شده‌اید",
  "Learn": "یادگیری",
  "Letters": "حروف",
  "Letters (default)": "حروف (پیش‌فرض)",
  "Light": "روشن",
  "Link (⌘K)": "پیوند (⌘K)",
  "List": "لیست",
  "List deleted": "لیست حذف شد",
  "List: {title}": "لیست: {title}",
  "Lists": "لیست‌ها",
  "Loading…": "در حال بارگذاری…",
  "Main calendar": "تقویم اصلی",
  "Members": "اعضا",
  "Mentions": "منشن‌ها",
  "Mentions, comments, invites, shared projects and deadline reminders": "منشن‌ها، کامنت‌ها، دعوت‌ها، پروژه‌های اشتراکی و یادآوری ددلاین",
  "Midnight": "نیمه‌شب",
  "Mobile layout": "چیدمان موبایل",
  "Mocha": "موکا",
  "Money": "پول",
  "More tags": "تگ‌های بیشتر",
  "Move down": "پایین",
  "Move left": "انتقال به راست",
  "Move right": "انتقال به چپ",
  "Move to Trash": "انتقال به سطل زباله",
  "Move up": "بالا",
  "Moved to Trash": "به سطل زباله منتقل شد",
  "Moved to {list}": "منتقل شد به {list}",
  "Moved {dir}": "جابه‌جا شد به {dir}",
  "My activity": "فعالیت‌های من",
  "My workspace": "فضای کاری من",
  "Name": "نام",
  "Needs review": "نیاز به بررسی",
  "New comments on your tasks and on tasks you commented on": "کامنت‌های جدید روی تسک‌های شما و تسک‌هایی که رویشان کامنت گذاشته‌اید",
  "New list": "لیست جدید",
  "New password (8+ characters)": "رمز عبور جدید (حداقل ۸ نویسه)",
  "New password needs at least 8 characters": "رمز عبور جدید باید حداقل ۸ نویسه باشد",
  "New project": "پروژه جدید",
  "New tag": "تگ جدید",
  "Newest": "جدیدترین",
  "Next week": "هفته بعد",
  "No changes yet.": "هنوز تغییری نیست.",
  "No deadline": "بدون مهلت",
  "No earlier versions yet. Edits are saved as versions.": "هنوز نسخهٔ قبلی‌ای نیست. ویرایش‌ها به‌صورت نسخه ذخیره می‌شوند.",
  "No icons match.": "آیکنی پیدا نشد.",
  "No list title": "لیست بدون عنوان",
  "No matches": "موردی پیدا نشد",
  "No mentions yet. Type @ and a name in a task's notes.": "هنوز منشنی نیست. در یادداشت یک تسک @ و یک نام بنویسید.",
  "No notifications yet.": "هنوز اعلانی نیست.",
  "No one with the username @{username}": "کسی با نام کاربری ‎@{username} وجود ندارد",
  "No open tasks.": "تسک بازی نیست.",
  "No pending invites.": "دعوت در انتظاری ندارید.",
  "No tag": "بدون تگ",
  "No tags": "تگی نیست",
  "No tags yet.": "هنوز تگی نیست.",
  "No tasks.": "تسکی نیست.",
  "None": "هیچ‌کدام",
  "Not allowed for your admin role": "برای نقش مدیریتی شما مجاز نیست",
  "Not available here": "اینجا در دسترس نیست",
  "Not checked": "انجام‌نشده",
  "Not now": "الان نه",
  "Not synced yet": "هنوز همگام نشده",
  "Notes": "یادداشت",
  "Notes · @ to mention, # to tag": "یادداشت · @ برای منشن، # برای تگ",
  "Notes · @ to mention, # to tag, paste images": "یادداشت · @ برای منشن، # برای تگ، تصویر را پیست کنید",
  "Notes · type @ to mention": "یادداشت · برای منشن @ بزنید",
  "Nothing found": "چیزی پیدا نشد",
  "Nothing to preview.": "چیزی برای پیش‌نمایش نیست.",
  "Nothing yet.": "هنوز چیزی نیست.",
  "Notifications": "اعلان‌ها",
  "Notifications are blocked for this site in your browser settings": "اعلان‌های این سایت در تنظیمات مرورگر مسدود شده است",
  "Numbered list": "فهرست شماره‌دار",
  "Offline": "آفلاین",
  "Offline · {n} saved on device": "آفلاین · {n} مورد روی دستگاه",
  "Offline — changes kept on this device": "آفلاین — تغییرات روی این دستگاه نگه داشته شد",
  "Oldest": "قدیمی‌ترین",
  "Oldest first": "قدیمی‌ترین‌ها",
  "On iPhone and iPad, add TaskCool to the Home Screen first (Share → Add to Home Screen)": "در آیفون و آیپد ابتدا TaskCool را به صفحه‌ی اصلی اضافه کنید (Share ← Add to Home Screen)",
  "Online checkout is unavailable: {reason}": "پرداخت آنلاین در دسترس نیست: {reason}",
  "Only owners and editors can manage links": "فقط مالکان و ویرایشگران می‌توانند پیوندها را مدیریت کنند",
  "Only the first 2,000 tasks are shown.": "فقط ۲٬۰۰۰ تسک نخست نمایش داده می‌شود.",
  "Only the project owner can change sharing": "فقط مالک پروژه می‌تواند اشتراک‌گذاری را تغییر دهد",
  "Open": "باز",
  "Open Markdown": "باز کردن مارک‌داون",
  "Open beside": "باز کردن در کنار",
  "Open large": "باز کردن در اندازهٔ بزرگ",
  "Open link": "باز کردن پیوند",
  "Open now": "باز در حال حاضر",
  "Open tasks": "تسک‌های باز",
  "Open tasks across all projects · top {n}": "تسک‌های باز همه پروژه‌ها · {n} مورد اول",
  "Open tasks across all projects · top {n} of {m}": "تسک‌های باز همه پروژه‌ها · {n} از {m}",
  "Open the app": "باز کردن برنامه",
  "Open this page in Chrome or Edge from its web address (not a local file). Then use this button, or the install icon in the address bar.": "این صفحه را از نشانی وب آن در کروم یا اج باز کنید (نه فایل محلی). سپس از این دکمه یا نماد نصب در نوار نشانی استفاده کنید.",
  "Open {brand}": "باز کردن {brand}",
  "Opening this file needs a connection.": "باز کردن این فایل به اتصال اینترنت نیاز دارد.",
  "Order used for the filter chips.": "ترتیبی که در فیلترها استفاده می‌شود.",
  "Original": "نسخهٔ اصلی",
  "Owner": "مالک",
  "Paper": "کاغذی",
  "Password": "رمز عبور",
  "Passwords don’t match": "رمزهای عبور یکسان نیستند",
  "Past due": "سررسید گذشته",
  "Payment provider not configured": "درگاه پرداخت پیکربندی نشده است",
  "Permissions for each role are set by the platform and enforced on the server.": "دسترسی‌های هر نقش توسط پلتفرم تعیین و در سرور اعمال می‌شود.",
  "Persian": "شمسی",
  "Pick a date": "انتخاب تاریخ",
  "Preview": "پیش‌نمایش",
  "Previewing {date}": "پیش‌نمایش {date}",
  "Privacy link": "لینک حریم خصوصی",
  "Private": "خصوصی",
  "Private project": "پروژه خصوصی",
  "Profile": "پروفایل",
  "Project moved to Trash": "پروژه به سطل زباله رفت",
  "Project name": "نام پروژه",
  "Project restored": "پروژه بازگردانده شد",
  "Project settings": "تنظیمات پروژه",
  "Project templates are not available yet.": "قالب‌های پروژه هنوز در دسترس نیستند.",
  "Project · {n} task": "پروژه · {n} تسک",
  "Project · {n} tasks": "پروژه · {n} تسک",
  "Projects": "پروژه‌ها",
  "Projects people have shared with you": "پروژه‌هایی که دیگران با شما به اشتراک گذاشته‌اند",
  "Push notifications on this device": "اعلان پوش روی این دستگاه",
  "Quote": "نقل‌قول",
  "Read-only": "فقط خواندنی",
  "Read-only link copied": "پیوند فقط‌خواندنی کپی شد",
  "Read-only links": "پیوندهای فقط‌خواندنی",
  "Ready to install": "آماده نصب",
  "Registration is closed for this site.": "ثبت‌نام در این سایت بسته است.",
  "Reload": "بارگذاری دوباره",
  "Remove": "حذف",
  "Remove deadline": "حذف مهلت",
  "Remove file": "حذف فایل",
  "Remove image": "حذف تصویر",
  "Remove item": "حذف مورد",
  "Remove photo": "حذف عکس",
  "Remove tag": "حذف تگ",
  "Restore": "بازگردانی",
  "Restored version from {date}": "بازگردانی نسخهٔ {date}",
  "Retry": "تلاش دوباره",
  "Revoked": "لغوشده",
  "Rose": "رز",
  "Sage": "مریمی",
  "Save password": "ذخیره رمز عبور",
  "Saved": "ذخیره شد",
  "Screen saver": "اسکرین‌سیور",
  "Search": "جست‌وجو",
  "Search icons": "جستجوی آیکن",
  "Search tasks and projects": "جستجوی تسک‌ها و پروژه‌ها",
  "See what's new": "دیدن تازه‌ها",
  "Send": "ارسال",
  "Send a test notification": "ارسال اعلان آزمایشی",
  "Send · Enter": "ارسال · Enter",
  "Sent — it should appear in a few seconds": "ارسال شد؛ تا چند ثانیه دیگر باید نمایش داده شود",
  "Settings": "تنظیمات",
  "Shared": "اشتراکی",
  "Shared by {name}": "اشتراک‌گذاشته‌شده توسط {name}",
  "Shared tag management is not available in the admin console yet.": "مدیریت تگ‌های مشترک هنوز در کنسول مدیریت در دسترس نیست.",
  "Shared with": "اشتراک‌گذاشته با",
  "Short name": "نام کوتاه",
  "Show done": "نمایش انجام‌شده‌ها",
  "Show projects": "نمایش پروژه‌ها",
  "Show stats when idle": "نمایش آمار هنگام بی‌حرکتی",
  "Show {n} logged item": "نمایش {n} مورد انجام‌شده",
  "Show {n} logged items": "نمایش {n} مورد انجام‌شده",
  "Show {n} logged project": "نمایش {n} پروژه تمام‌شده",
  "Show {n} logged projects": "نمایش {n} پروژه تمام‌شده",
  "Showing the first 1,000 users. Refine the search to find others.": "۱۰۰۰ کاربر اول نمایش داده می‌شود. برای یافتن بقیه جستجو را دقیق‌تر کنید.",
  "Shown next to the project and in the collapsed menu": "کنار پروژه و در منوی فشرده نمایش داده می‌شود",
  "Side by side": "کنار هم",
  "Sign in": "ورود",
  "Sign in again to save": "برای ذخیره دوباره وارد شوید",
  "Sign in to Task Panes": "ورود به Task Panes",
  "Sign in to TaskCool": "ورود به TaskCool",
  "Sign in to sync": "برای همگام‌سازی وارد شوید",
  "Sign in to {brand}": "ورود به {brand}",
  "Sign out": "خروج",
  "Sign-ups per week": "ثبت‌نام در هر هفته",
  "Signed in as {email}": "وارد شده با {email}",
  "Single column": "تک‌ستونی",
  "Someone": "کسی",
  "Someone else changed the same thing while you were offline. Nothing was overwritten.": "شخص دیگری همین مورد را هم‌زمان تغییر داده است. هیچ چیز بازنویسی نشد.",
  "Something went wrong. Reload to try again.": "مشکلی پیش آمد. برای تلاش دوباره صفحه را بارگذاری کنید.",
  "Something went wrong. Try again.": "مشکلی پیش آمد. دوباره تلاش کنید.",
  "Split": "دوستونه",
  "Stats": "آمار",
  "Strikethrough": "خط‌خورده",
  "Support": "پشتیبانی",
  "Support email": "ایمیل پشتیبانی",
  "Support link": "لینک پشتیبانی",
  "Switch account": "تغییر حساب",
  "Sync first, then try again": "اول همگام‌سازی کنید، سپس دوباره امتحان کنید",
  "Sync now, then sign out": "همگام‌سازی و سپس خروج",
  "Synced": "همگام شد",
  "Syncing…": "در حال همگام‌سازی…",
  "System": "سیستم",
  "Tag": "تگ",
  "Tag: {tag}": "تگ: {tag}",
  "Tags": "تگ‌ها",
  "Tap again to discard {n} changes": "برای دور ریختن {n} تغییر دوباره بزنید",
  "Task Panes": "Task Panes",
  "Task added": "تسک اضافه شد",
  "Task moved": "تسک جابه‌جا شد",
  "Task restored": "تسک بازگردانی شد",
  "Task title": "عنوان تسک",
  "Task updated": "تسک به‌روز شد",
  "TaskCool": "TaskCool",
  "Tasks": "تسک‌ها",
  "Tasks can’t be moved to a project of another workspace": "تسک را نمی‌توان به پروژه‌ای در فضای کاری دیگر منتقل کرد",
  "Tech": "فناوری",
  "Terms link": "لینک شرایط استفاده",
  "The Google sign-in expired. Try again.": "مهلت ورود با گوگل تمام شد. دوباره تلاش کنید.",
  "The link is invalid or no longer available. Ask the sender for a new one.": "این لینک نامعتبر است یا دیگر در دسترس نیست. از فرستنده لینک تازه بخواهید.",
  "The task was deleted": "این تسک حذف شده است",
  "Theirs": "دیگران",
  "Theme: {name}": "پوسته: {name}",
  "This account is disabled.": "این حساب غیرفعال است.",
  "This action needs a connection": "این کار به اتصال اینترنت نیاز دارد",
  "This address is not set up yet. If you manage this site, finish verifying the domain.": "این نشانی هنوز راه‌اندازی نشده است. اگر مدیر این سایت هستید، تأیید دامنه را کامل کنید.",
  "This browser cannot show notifications": "این مرورگر نمی‌تواند اعلان نشان دهد",
  "This change exceeds the workspace plan limit. It was not applied; your text is kept below.": "این تغییر از سقف طرح اشتراک این فضای کاری بیشتر است. اعمال نشد؛ متن شما در زیر حفظ شده است.",
  "This email is already linked to a different Google account.": "این ایمیل به حساب گوگل دیگری متصل است.",
  "This file can’t be edited as Markdown": "این فایل را نمی‌توان به‌صورت مارک‌داون ویرایش کرد",
  "This file is no longer attached to its task.": "این فایل دیگر به تسک خود پیوست نیست.",
  "This file is no longer available": "این فایل دیگر در دسترس نیست",
  "This file was changed by {name}. Your text is kept here.": "{name} این فایل را تغییر داده است. متن شما اینجا نگه داشته شده است.",
  "This invitation has expired. Ask for a new one.": "این دعوت‌نامه منقضی شده است. دعوت تازه بخواهید.",
  "This invitation is no longer valid.": "این دعوت‌نامه دیگر معتبر نیست.",
  "This invitation was sent to a different email address. Sign in with that address to accept.": "این دعوت‌نامه برای ایمیل دیگری فرستاده شده است. برای پذیرفتن با همان ایمیل وارد شوید.",
  "This invite is no longer available": "این دعوت دیگر در دسترس نیست",
  "This is an earlier version and can’t be edited. Restore it to make changes.": "این نسخهٔ قبلی است و ویرایش نمی‌شود. برای تغییر، آن را بازگردانی کنید.",
  "This link is no longer available": "این پیوند دیگر در دسترس نیست",
  "This list has {n} task. What should happen to them?": "این لیست {n} تسک دارد. با آن‌ها چه شود؟",
  "This list has {n} tasks. What should happen to them?": "این لیست {n} تسک دارد. با آن‌ها چه شود؟",
  "This project was moved to Trash, so your change was not applied. Your text is kept below; you can apply it again after the project is restored.": "این پروژه به سطل زباله منتقل شده است، پس تغییر شما اعمال نشد. متن شما در زیر نگه داشته شده است؛ پس از بازگرداندن پروژه می‌توانید دوباره اعمالش کنید.",
  "This task was deleted by someone else. Your change was not applied.": "این تسک توسط شخص دیگری حذف شده است. تغییر شما اعمال نشد.",
  "This workspace is read-only until its subscription is active again. Your change was not applied; your text is kept below.": "این فضای کاری تا فعال شدن دوبارهٔ اشتراک فقط‌خواندنی است. تغییر شما اعمال نشد؛ متن شما در زیر حفظ شده است.",
  "Throughput": "بازدهی",
  "Today": "امروز",
  "Today: {d}": "امروز: {d}",
  "Tomorrow": "فردا",
  "Too large to save (max 1 MB)": "برای ذخیره بیش از حد بزرگ است (حداکثر ۱ مگابایت)",
  "Too many attempts. Try again later.": "تلاش‌های زیاد. بعداً دوباره امتحان کنید.",
  "Too many attempts; try again later": "تلاش‌های زیاد؛ کمی بعد دوباره امتحان کنید",
  "Too many pending invites for this project": "دعوت‌های در انتظار این پروژه بیش از حد است",
  "Too many requests. Try again in a few minutes.": "درخواست‌ها بیش از حد است. چند دقیقه دیگر دوباره امتحان کنید.",
  "Trash": "سطل زباله",
  "Trash emptied": "سطل زباله خالی شد",
  "Trash is empty.": "سطل زباله خالی است.",
  "Travel": "سفر",
  "Trial": "آزمایشی",
  "Try again": "دوباره تلاش کنید",
  "Turn off link": "خاموش کردن پیوند",
  "Turn on push notifications on this device first": "ابتدا اعلان پوش را روی این دستگاه روشن کنید",
  "Type {word} to confirm": "برای تأیید، {word} را تایپ کنید",
  "Undo": "بازگردانی",
  "Unlimited": "نامحدود",
  "Unread": "خوانده‌نشده",
  "Unsynced changes": "تغییرات همگام‌نشده",
  "Untitled": "بدون عنوان",
  "Untitled list": "لیست بدون عنوان",
  "Updated": "به‌روز شد",
  "Updates": "به‌روزرسانی‌ها",
  "Use 3–30 letters, numbers, dots or underscores": "از ۳ تا ۳۰ حرف انگلیسی، عدد، نقطه یا زیرخط استفاده کنید",
  "Use a JPEG, PNG or WebP image": "از تصویر JPEG، PNG یا WebP استفاده کنید",
  "Use another account": "استفاده از حساب دیگر",
  "Use mine": "استفاده از نسخهٔ من",
  "Use their version": "نسخهٔ آن‌ها",
  "Use your email and password.": "با ایمیل و رمز عبور وارد شوید.",
  "Username": "نام کاربری",
  "Username can’t be empty": "نام کاربری نمی‌تواند خالی باشد",
  "Version history": "تاریخچهٔ نسخه‌ها",
  "Version history needs a connection.": "تاریخچهٔ نسخه‌ها به اتصال اینترنت نیاز دارد.",
  "View": "نما",
  "View image": "نمایش تصویر",
  "Visibility": "نمایش",
  "Week of {d}": "هفته {d}",
  "What's new": "تازه‌ها",
  "When someone shares a project": "وقتی کسی پروژه‌ای را به اشتراک می‌گذارد",
  "Whole project": "کل پروژه",
  "Work": "کار",
  "Workspace": "فضای کاری",
  "Workspace storage is full": "فضای ذخیره‌سازی فضای کار پر است",
  "Workspace subscriptions": "اشتراک فضاهای کاری",
  "Workspaces": "فضاهای کاری",
  "Workspaces on this plan": "فضاهای کاری این پلن",
  "Write Markdown…": "مارک‌داون بنویسید…",
  "Yesterday": "دیروز",
  "You": "شما",
  "You are offline": "آفلاین هستید",
  "You are offline. Accepting an invitation needs a connection.": "آفلاین هستید. پذیرفتن دعوت به اتصال اینترنت نیاز دارد.",
  "You are offline. Open the app once while online to use it offline on this device.": "آفلاین هستید. برای استفادهٔ آفلاین، یک بار برنامه را در حالت آنلاین باز کنید.",
  "You are offline. Signing in needs a connection.": "آفلاین هستید. ورود به اتصال نیاز دارد.",
  "You are offline. The admin console needs a connection.": "آفلاین هستید. کنسول مدیریت به اتصال اینترنت نیاز دارد.",
  "You can only view this file": "شما فقط اجازهٔ دیدن این فایل را دارید",
  "You do not have permission to view this section.": "دسترسی مشاهده این بخش را ندارید.",
  "You no longer have access to this item. Your change was not applied.": "دیگر به این مورد دسترسی ندارید. تغییر شما اعمال نشد.",
  "Your Google email address is not verified.": "ایمیل حساب گوگل شما تأیید نشده است.",
  "Your account does not have access to the admin console.": "حساب شما به کنسول مدیریت دسترسی ندارد.",
  "Your change could not be applied.": "تغییر شما اعمال نشد.",
  "Your change could not be saved on this device.": "تغییر شما روی این دستگاه ذخیره نشد.",
  "Your change was copied": "تغییر شما کپی شد",
  "Your last {n} changes": "{n} تغییر آخر شما",
  "Your last {n} changes of {m}": "{n} تغییر آخر شما از {m}",
  "Yours": "شما",
  "by you": "توسط شما",
  "by {name}": "توسط {name}",
  "commented on a task you commented on": "روی تسکی که رویش کامنت گذاشته‌اید کامنت گذاشت",
  "commented on your task": "روی تسک شما کامنت گذاشت",
  "completed ÷ added": "تکمیل‌شده ÷ اضافه‌شده",
  "completed ÷ added · can exceed 100%": "تکمیل‌شده ÷ اضافه‌شده · می‌تواند بیش از ۱۰۰٪ باشد",
  "delete": "حذف",
  "down": "پایین",
  "editor": "ویرایشگر",
  "mentioned you": "شما را منشن کرد",
  "month": "ماه",
  "of {n} tasks": "از {n} تسک",
  "on this device": "روی این دستگاه",
  "or": "یا",
  "owner": "مالک",
  "per day": "در روز",
  "per month": "در ماه",
  "per week": "در هفته",
  "scroll up for earlier": "برای موارد قبلی بالا بروید",
  "the top list": "لیست بالا",
  "today": "امروز",
  "up": "بالا",
  "viewer": "بیننده",
  "workspaces": "فضای کاری",
  "year": "سال",
  "{a} ago": "{a} پیش",
  "{done}/{n} checklist": "{done}/{n} چک‌لیست",
  "{inviter} invited you as {role}.": "{inviter} شما را با نقش {role} دعوت کرده است.",
  "{inviter} invited you to {project}. Sign in or create an account with {email} to join.": "{inviter} شما را به {project} دعوت کرده است. برای پیوستن با {email} وارد شوید یا حساب بسازید.",
  "{lists} and {tasks} move to Trash for everyone it’s shared with. You can restore it within 30 days.": "{lists} و {tasks} برای همهٔ کسانی که پروژه با آن‌ها به اشتراک گذاشته شده به سطل زباله می‌روند. تا ۳۰ روز می‌توانید آن را بازگردانید.",
  "{name} invited you": "{name} شما را دعوت کرد",
  "{name}’s workspace": "فضای کاری {name}",
  "{n} change": "{n} تغییر",
  "{n} changes": "{n} تغییر",
  "{n} changes on this device have not reached the server yet.": "{n} تغییر روی این دستگاه هنوز به سرور نرسیده است.",
  "{n} comment": "{n} کامنت",
  "{n} comments": "{n} کامنت",
  "{n} day left": "{n} روز مانده",
  "{n} days left": "{n} روز مانده",
  "{n} file": "{n} فایل",
  "{n} files": "{n} فایل",
  "{n} icons": "{n} آیکن",
  "{n} list": "{n} لیست",
  "{n} lists": "{n} لیست",
  "{n} member": "{n} عضو",
  "{n} members": "{n} عضو",
  "{n} open task": "{n} تسک باز",
  "{n} open tasks": "{n} تسک باز",
  "{n} open tasks by list": "{n} تسک باز بر اساس لیست",
  "{n} project and everything else in Trash will be deleted forever. This can’t be undone.": "{n} پروژه و هر چیز دیگری در سطل زباله برای همیشه حذف می‌شود. این کار برگشت‌پذیر نیست.",
  "{n} projects and everything else in Trash will be deleted forever. This can’t be undone.": "{n} پروژه و هر چیز دیگری در سطل زباله برای همیشه حذف می‌شوند. این کار برگشت‌پذیر نیست.",
  "{n} saved on device": "{n} مورد روی دستگاه ذخیره شده",
  "{n} task": "{n} تسک",
  "{n} tasks": "{n} تسک",
  "· pre-release": "· پیش از انتشار",
  "· prototype": "· نمونه اولیه",
  "⚑ Deadline": "⚑ مهلت",
  "More filters": "فیلترهای بیشتر",
  "Edit filter order…": "ویرایش ترتیب فیلترها…",
  "More themes": "تم‌های بیشتر",
  "Assignees": "افراد اساین‌شده",
  " · @ to mention, # to tag, paste images": " · @ برای منشن، # برای تگ، پیست تصویر",
  "Reopen": "باز کردن دوباره",
  "Sort": "مرتب‌سازی",
  "Done in 7 days": "انجام‌شده در ۷ روز",
  "Project stats": "آمار پروژه",
  "Project team": "تیم پروژه",
  "Filter order": "ترتیب فیلترها",
  "Back": "بازگشت",
  "Nickname in this project": "نیک‌نیم در این پروژه",
  "Rename tag": "تغییر نام تگ",
  "Drag to set the order of people and tags in the filter row.": "برای تعیین ترتیب افراد و تگ‌ها در ردیف فیلتر، بکشید.",
  "Built-in filter, can’t be deleted": "فیلتر پیش‌فرض، حذف‌شدنی نیست",
  "{name} (you)": "{name} (شما)",
  "{n} invited": "{n} دعوت‌شده",
  "Tag names can be up to 100 characters": "نام تگ حداکثر ۱۰۰ نویسه است",
  "Tags merged": "تگ‌ها ادغام شدند",
  "Tag renamed": "نام تگ تغییر کرد",
  "No one": "هیچ‌کس",
  "Me": "من",
  "Duplicate": "تکثیر",
  "Copy title": "کپی عنوان",
  "Title copied": "عنوان کپی شد",
  "Move to {list}": "انتقال به {list}",
  "Filter for tasks with nobody assigned": "فیلتر تسک‌هایی که به کسی اساین نشده‌اند",
  "Search & sort": "جستجو و مرتب‌سازی",
  "Assigned to me": "اساین‌شده به من",
  "Assigned to {name}": "اساین‌شده به {name}",
  "Tasks with no one assigned": "تسک‌هایی که به کسی اساین نشده‌اند",
  "Unassign {name}": "حذف اساین {name}",
  "Assign to {name}": "اساین به {name}",
  "Hide trashed items": "پنهان کردن موارد حذف‌شده",
  "Deleted {d}": "حذف‌شده {d}",
  "Done {r}": "انجام‌شده {r}",
  "Done {d}": "انجام‌شده {d}",
  "Drop to move this project to Trash": "رها کنید تا این پروژه به سطل زباله برود",
  "Only the owner can delete this project": "فقط مالک می‌تواند این پروژه را حذف کند",
  "Only the owner can delete “{name}”": "فقط مالک می‌تواند «{name}» را حذف کند",
  "“{name}” moved to Trash": "«{name}» به سطل زباله رفت",
  "Sort: {label}": "مرتب‌سازی: {label}",
  "Mark as done": "انجام شد",
  "Assign to me": "اساین به خودم",
  "Unassign me": "حذف اساین من",
  "{n} person": "{n} نفر",
  "{n} people": "{n} نفر",
  "Show {n} trashed item": "نمایش {n} مورد حذف‌شده",
  "Show {n} trashed items": "نمایش {n} مورد حذف‌شده",
  "Wine": "شرابی",
  "This browser can’t open that photo format (for example HEIC). Use a JPEG, PNG or WebP image": "این مرورگر نمی‌تواند این قالب عکس (مثلاً HEIC) را باز کند. از تصویر JPEG، PNG یا WebP استفاده کنید",
  "Password changed": "رمز عبور تغییر کرد",
  "Choose a new password": "رمز عبور جدید را انتخاب کنید",
  "Sign in with your new password. You were signed out on your other devices.": "با رمز جدید وارد شوید. از دستگاه‌های دیگر خارج شدید.",
  "For your {brand} account.": "برای حساب {brand} شما.",
  "New password": "رمز جدید",
  "Repeat": "تکرار",
  "Use a password of at least 8 characters.": "رمزی با دست‌کم ۸ نویسه انتخاب کنید.",
  "The passwords do not match.": "دو رمز یکسان نیستند.",
  "This link has expired or was already used. Ask for a new one.": "این لینک منقضی شده یا قبلاً استفاده شده است. لینک تازه بخواهید.",
  "TaskCool is being updated. Try again in a few minutes.": "تسکول در حال به‌روزرسانی است. چند دقیقه دیگر دوباره امتحان کنید.",
  "You are offline. This needs a connection.": "آفلاین هستید. این کار به اینترنت نیاز دارد.",
  "Registration on this site is by invitation only.": "ثبت‌نام در این سایت فقط با دعوت ممکن است.",
  "Google sign-in is turned off for this site.": "ورود با گوگل برای این سایت خاموش است.",
  "Assign": "اساین",
  "Assign all to me": "اساین همه به خودم",
  "Clear selection · Esc": "پاک کردن انتخاب · Esc",
  "Comment copied": "کامنت کپی شد",
  "Comment deleted": "کامنت حذف شد",
  "Comment on the project…": "کامنت روی پروژه…",
  "Copy text": "کپی متن",
  "Copy titles": "کپی عنوان‌ها",
  "Create tag “{q}”": "ساخت تگ «{q}»",
  "Drag to move · right-click for actions": "برای جابه‌جایی بکشید · کلیک راست برای عملیات",
  "Drag to set the order of people, lists and tags in the filter row.": "برای تعیین ترتیب افراد، لیست‌ها و تگ‌ها در ردیف فیلتر، بکشید.",
  "Duplicate all": "تکثیر همه",
  "Emoji": "ایموجی",
  "Filter": "فیلتر",
  "Hide comments": "پنهان کردن کامنت‌ها",
  "Hide details": "پنهان کردن جزئیات",
  "Show details": "نمایش جزئیات",
  "Show comments": "نمایش کامنت‌ها",
  "Image": "عکس",
  "Mark all as done": "همه انجام شد",
  "Reopen all": "باز کردن دوباره‌ی همه",
  "Unassign me from all": "حذف اساین من از همه",
  "More": "بیشتر",
  "Move {n} to Trash": "انتقال {n} مورد به سطل زباله",
  "Next · →": "بعدی · →",
  "Previous · ←": "قبلی · ←",
  "Nothing to add": "چیزی برای افزودن نیست",
  "Only lists named “{name}” (all projects)": "فقط لیست‌های با نام «{name}» (همه‌ی پروژه‌ها)",
  "Only the list “{name}”": "فقط لیست «{name}»",
  "Open in new column": "باز کردن در ستون جدید",
  "People": "افراد",
  "Project comments": "کامنت‌های پروژه",
  "Project discussion": "گفتگوی پروژه",
  "Recently updated": "تازه‌ترین تغییرات",
  "Single task": "تک تسک",
  "Task now has {x}": "تسک اکنون {x} دارد",
  "{n} tasks now have {x}": "{n} تسک اکنون {x} دارند",
  "Unassign": "حذف اساین",
  "Your comment": "کامنت شما",
  "added this task": "این تسک را اضافه کرد",
  "changed this task": "این تسک را تغییر داد",
  "commented": "کامنت گذاشت",
  "commented on the project": "روی پروژه کامنت گذاشت",
  "and": "و",
  "checklist": "چک‌لیست",
  "deadline": "مهلت",
  "notes": "یادداشت",
  "hide {x}": "پنهان کردن {x}",
  "{name}’s comment": "کامنت {name}",
  "{n} tasks moved to Trash": "{n} تسک به سطل زباله منتقل شد",
  "{n} tasks selected": "{n} تسک انتخاب شده",
  "{n} titles copied": "{n} عنوان کپی شد",
  "· @ to mention, # to tag, paste images": "· @ برای منشن، # برای تگ، پیست عکس",
  "{n} attachment": "{n} پیوست",
  "{n} attachments": "{n} پیوست",
  "{n} comment on this project": "{n} کامنت روی این پروژه",
  "{n} comments on this project": "{n} کامنت روی این پروژه",
  "(click to switch)": "(برای جابه‌جایی کلیک کنید)",
  "Accent": "رنگ اکسنت",
  "All changes saved to cloud": "همه‌ی تغییرات در فضای ابری ذخیره شد",
  "App accent": "اکسنت اپ",
  "Attach image or file": "پیوست عکس یا فایل",
  "Auto": "خودکار",
  "Auto (follow app)": "خودکار (مثل اپ)",
  "Cancel reply · Esc": "لغو پاسخ · Esc",
  "Changes are saved on this device · {n} waiting to sync": "تغییرات روی همین دستگاه ذخیره می‌شوند · {n} در انتظار همگام‌سازی",
  "Changes save to cloud": "تغییرات در فضای ابری ذخیره می‌شوند",
  "Changes will be saved on this device": "تغییرات روی همین دستگاه ذخیره می‌شوند",
  "Changes will be saved on this device and synced when you’re back online": "تغییرات روی همین دستگاه ذخیره و بعد از آنلاین شدن همگام می‌شوند",
  "Click the link to copy": "برای کپی روی لینک کلیک کنید",
  "Click to copy": "برای کپی کلیک کنید",
  "Connected. Every change is saved to the cloud right away.": "متصل. هر تغییر همان لحظه در فضای ابری ذخیره می‌شود.",
  "Copied ✓": "کپی شد ✓",
  "Delete desktop": "حذف دسکتاپ",
  "Deleted comment": "کامنت حذف‌شده",
  "Desktop name": "نام دسکتاپ",
  "Desktop {n}": "دسکتاپ {n}",
  "Desktops": "دسکتاپ‌ها",
  "Duplicate this desktop": "کپی این دسکتاپ",
  "Go to the original comment": "رفتن به کامنت اصلی",
  "Hide {x}": "پنهان کردن {x}",
  "In {names}": "در {names}",
  "Invite": "دعوت",
  "Main": "اصلی",
  "Matches from your other projects": "نتایج از پروژه‌های دیگر شما",
  "New empty desktop": "دسکتاپ خالی جدید",
  "No internet connection. Changes are kept on this device and will sync when you’re back online.": "اینترنت وصل نیست. تغییرات روی همین دستگاه نگه داشته می‌شوند و بعد از اتصال همگام می‌شوند.",
  "No one matches. Press Enter to invite by email or @username.": "کسی پیدا نشد. برای دعوت با ایمیل یا ‎@username‎ اینتر بزنید.",
  "Online": "آنلاین",
  "People from your other projects": "افراد پروژه‌های دیگر شما",
  "Rename": "تغییر نام",
  "Reply": "پاسخ",
  "Replying to {name}": "در پاسخ به {name}",
  "Saving to cloud…": "در حال ذخیره در فضای ابری…",
  "Search, or invite by email or @username": "جستجو، یا دعوت با ایمیل یا ‎@username",
  "Show {x}": "نمایش {x}",
  "Syncing {x}…": "در حال همگام‌سازی {x}…",
  "Team": "تیم",
  "Theme": "تم",
  "Use app accent": "استفاده از اکسنت اپ",
  "Your session ended. Sign in again to sync; nothing is lost.": "نشست شما تمام شده. برای همگام‌سازی دوباره وارد شوید؛ چیزی از دست نمی‌رود.",
  "You’re offline": "آفلاین هستید",
  "col": "ستون",
  "follows app": "مثل اپ",
  "yourself": "خودتان",
  "{x} saved on this device": "{x} روی همین دستگاه ذخیره شد",
  "⌃1–9 to switch": "⌃1–9 برای جابه‌جایی",
  "Blue": "آبی",
  "Red": "قرمز",
  "Orange": "نارنجی",
  "Yellow": "زرد",
  "Green": "سبز",
  "Teal": "فیروزه‌ای",
  "Purple": "بنفش",
  "Pink": "صورتی",
  "Violet": "بنفش تیره",
  "Custom": "سفارشی",
  "copy": "کپی",
  "copied": "کپی شد",
  "Person or tag": "فرد یا تگ",
  "Suggested": "پیشنهادی",
  "Online with changes saved to the cloud": "آنلاین",
  "Image saved": "تصویر ذخیره شد",
  "Couldn’t save this image": "ذخیره‌ی این تصویر ممکن نشد",
  "Image copied": "تصویر کپی شد",
  "Image link copied": "لینک تصویر کپی شد",
  "Copy isn’t allowed here": "کپی در اینجا مجاز نیست",
  "Copy image": "کپی تصویر",
  "Save image": "ذخیره‌ی تصویر",
  "Installed app": "اپ نصب‌شده",
  "{os} app": "اپ {os}",
  "Web browser": "مرورگر وب",
  "Devices need a connection": "دیدن دستگاه‌ها به اینترنت نیاز دارد",
  "Could not load your devices": "دستگاه‌ها بارگذاری نشدند",
  "Active now": "فعال",
  "{n} min ago": "{n} دقیقه پیش",
  "{n} h ago": "{n} ساعت پیش",
  "{n} d ago": "{n} روز پیش",
  "Confirm": "تأیید",
  "Revoke": "خروج",
  "{name} signed out": "از {name} خارج شد",
  "Could not sign out that device": "خروج از آن دستگاه ممکن نشد",
  "{n} signed in": "{n} دستگاه وارد شده",
  "Signed out of {n} other devices": "از {n} دستگاه دیگر خارج شد",
  "Could not sign out the other devices": "خروج از دستگاه‌های دیگر ممکن نشد",
  "Devices": "دستگاه‌ها",
  "This device": "این دستگاه",
  "Sign out of all other devices": "خروج از همه‌ی دستگاه‌های دیگر",
  "In Trash": "در سطل زباله",
  "Created by you": "ساخته‌شده توسط شما",
  "Created by {name}": "ساخته‌شده توسط {name}",
  "React": "واکنش",
  "Open in a new column": "باز کردن در ستون جدید",
  "Copy": "کپی",
  "Save": "ذخیره",
  "When someone assigns you a task": "وقتی کسی تسکی را به شما می‌سپارد",
  "Web": "وب",
  "API keys need a connection": "کلیدهای API به اتصال اینترنت نیاز دارند",
  "Could not load your API keys": "کلیدهای API بارگذاری نشد",
  "Key {n}": "کلید {n}",
  "You have the maximum number of API keys": "به حداکثر تعداد کلید API رسیده‌اید",
  "Could not create the key": "ساخت کلید انجام نشد",
  "Copied": "کپی شد",
  "Created {d}": "ساخته‌شده {d}",
  "Last used {d}": "آخرین استفاده {d}",
  "Never used": "هنوز استفاده نشده",
  "Key revoked": "کلید باطل شد",
  "Could not revoke the key": "باطل کردن کلید انجام نشد",
  "Telegram needs a connection": "تلگرام به اتصال اینترنت نیاز دارد",
  "Could not load the Telegram settings": "تنظیمات تلگرام بارگذاری نشد",
  "Could not save the Telegram settings": "تنظیمات تلگرام ذخیره نشد",
  "Not available": "در دسترس نیست",
  "Connected": "وصل",
  "Not connected": "وصل نیست",
  "Open {bot} and send this code. It links the bot to your account and expires in 10 minutes.": "{bot} را باز کنید و این کد را بفرستید. این کد بات را به حساب شما وصل می‌کند و تا ۱۰ دقیقه معتبر است.",
  "Since {d}": "از {d}",
  "Checking…": "در حال بررسی…",
  "I’ve sent it": "فرستادم",
  "Telegram connected": "تلگرام وصل شد",
  "Not connected yet. Send the code to the bot, then try again.": "هنوز وصل نشده. کد را برای بات بفرستید و دوباره امتحان کنید.",
  "Telegram disconnected": "اتصال تلگرام قطع شد",
  "Could not disconnect Telegram": "قطع اتصال تلگرام انجام نشد",
  "Top of project": "بالای پروژه",
  "Test task added to {name}": "تسک آزمایشی به {name} اضافه شد",
  "Could not add the test task": "افزودن تسک آزمایشی انجام نشد",
  "Comments, mentions and invites": "کامنت‌ها، منشن‌ها و دعوت‌ها",
  "Right-click a task, or use ⋯ on an open task, and choose Bookmark": "روی تسکی راست‌کلیک کنید یا در تسک باز از ⋯ گزینه‌ی بوک‌مارک را بزنید",
  "Remove bookmark": "حذف بوک‌مارک",
  "Bookmark": "بوک‌مارک",
  "Bookmarks": "بوک‌مارک‌ها",
  "Bookmarked": "بوک‌مارک شد",
  "Bookmark removed": "بوک‌مارک حذف شد",
  "API keys": "کلیدهای API",
  "Use a key to read and change your projects and tasks from your own scripts. A key acts as you, so keep it private.": "با یک کلید، اسکریپت‌های خودتان می‌توانند پروژه‌ها و تسک‌هایتان را بخوانند و تغییر دهند. کلید به‌جای شما عمل می‌کند، پس آن را محرمانه نگه دارید.",
  "{name} is ready": "{name} آماده است",
  "Copy it now. For your security it won’t be shown again.": "همین حالا کپی‌اش کنید. برای امنیت شما دیگر نمایش داده نمی‌شود.",
  "I’ve saved it": "ذخیره‌اش کردم",
  "Key name": "نام کلید",
  "Key name, e.g. My script": "نام کلید، مثلاً اسکریپت من",
  "Create key": "ساخت کلید",
  "Keep": "نگه دار",
  "Revoke||key": "باطل کن",
  "No API keys yet.": "هنوز کلید API ندارید.",
  "Example": "نمونه",
  "{n} key": "{n} کلید",
  "{n} keys": "{n} کلید",
  "Send messages to the {brand} bot in Telegram and they arrive here as tasks.": "به بات {brand} در تلگرام پیام بدهید تا به‌صورت تسک اینجا بیایند.",
  "1 · Connect the bot": "۱ · اتصال بات",
  "Telegram isn’t available on this server yet. Your settings below are kept for when it is.": "تلگرام هنوز روی این سرور فعال نیست. تنظیمات زیر برای وقتی که فعال شود نگه داشته می‌شوند.",
  "Copy code": "کپی کد",
  "Open Telegram": "باز کردن تلگرام",
  "Connected as": "وصل با",
  "Disconnect": "قطع اتصال",
  "2 · Where tasks go": "۲ · تسک‌ها کجا بروند",
  "Project": "پروژه",
  "Start a message with #project-name to send it to another project for that one message.": "اگر پیام را با ‎#نام-پروژه شروع کنید، فقط همان پیام به پروژه‌ی دیگری می‌رود.",
  "3 · How messages are read": "۳ · پیام‌ها چطور خوانده شوند",
  "Turn into a task": "تبدیل به تسک",
  "First line is the title": "خط اول عنوان است",
  "The rest goes into notes": "بقیه به یادداشت می‌رود",
  "#hashtags become tags": "‎#هشتگ‌ها تگ می‌شوند",
  "@usernames are assigned": "‎@نام‌کاربری‌ها اساین می‌شوند",
  "Attach photos and files": "پیوست عکس‌ها و فایل‌ها",
  "Replies become comments": "ریپلای‌ها کامنت می‌شوند",
  "Reply to the bot’s “Task added” message": "به پیام «تسک اضافه شد» بات ریپلای کنید",
  "Send a test task": "فرستادن تسک آزمایشی",
  "Every message": "هر پیام",
  "Only with #task": "فقط با ‎#task",
  "Send GIF": "فرستادن گیف",
  "GIF": "گیف",
  "{n} of {m} bookmarked task": "{n} از {m} تسک بوک‌مارک‌شده",
  "{n} of {m} bookmarked tasks": "{n} از {m} تسک بوک‌مارک‌شده",
  "{n} pending invite": "{n} دعوت در انتظار",
  "{n} pending invites": "{n} دعوت در انتظار",
  "{n} tasks you created": "{n} تسکی که ساختید",
  "{n} tasks you completed": "{n} تسکی که انجام دادید",
  "{n} edits": "{n} ویرایش",
  "{n} moves": "{n} جابه‌جایی",
  "{n} trash and restore actions": "{n} حذف و بازگردانی",
  "Created": "ساخته‌شده",
  "Edited": "ویرایش‌شده",
  "Commented": "کامنت‌شده",
  "Moved": "جابه‌جاشده",
  "Comments": "کامنت‌ها",
  "No new comments.": "کامنت تازه‌ای نیست.",
  "No one has mentioned you yet.": "هنوز کسی شما را منشن نکرده است.",
  "Nearest deadline first": "نزدیک‌ترین مهلت اول"
}
